<template>
  <span class="font-mono tabular-nums">{{ prefix }}{{ formatted }}{{ suffix }}</span>
</template>

<script setup>
import { ref, computed, watch, onMounted, onUnmounted } from 'vue';

const props = defineProps({
  value: { type: Number, required: true },
  decimals: { type: Number, default: 0 },
  prefix: { type: String, default: '' },
  suffix: { type: String, default: '' },
  duration: { type: Number, default: 800 },
});

const display = ref(0);
let rafId = null;

function tween(from, to) {
  if (rafId) cancelAnimationFrame(rafId);
  const start = performance.now();
  const dur = Math.max(props.duration, 16);

  const step = (now) => {
    const t = Math.min((now - start) / dur, 1);
    const eased = 1 - Math.pow(1 - t, 3); // ease-out cubic
    display.value = from + (to - from) * eased;
    if (t < 1) {
      rafId = requestAnimationFrame(step);
    } else {
      display.value = to;
      rafId = null;
    }
  };
  rafId = requestAnimationFrame(step);
}

watch(
  () => props.value,
  (nv) => tween(Number(display.value) || 0, Number(nv) || 0)
);

onMounted(() => tween(0, Number(props.value) || 0));
onUnmounted(() => { if (rafId) cancelAnimationFrame(rafId); });

const formatted = computed(() =>
  (Number(display.value) || 0).toLocaleString('pt-BR', {
    minimumFractionDigits: props.decimals,
    maximumFractionDigits: props.decimals,
  })
);
</script>
